import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import SignIn from "./views/auth/SignIn";
import Forbidden from "./views/auth/Forbidden";
import LireNotification from "views/admin/lire_message";
import ArticleDetailsPage from "views/admin/articles_details";
import ArticlesEditsView from "views/admin/articles_edits";

const App = () => {
  return (
    <Routes>
      <Route path="auth/sign-in" element={<SignIn />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="admin/notifications/:id" element={<LireNotification />} />

      {/* Route pour les détails d'un article par slug */}
      <Route
        path="/admin/article/details/:slug"
        element={<ArticleDetailsPage />}
      />
      <Route
        path="/admin/article/edit/:id_art"
        element={<ArticlesEditsView />}
      />

      {/* Redirection vers la page d'accueil de l'admin */}
      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route path="/forbidden" element={<Forbidden />} key="forbidden" />

      {/* Redirection vers la page de connexion pour toutes les routes non définies (404) */}
      <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
    </Routes>
  );
};

export default App;
